import React, { useCallback } from "react";
import { Box, Slider as MUISlider } from "@mui/material";
import { DEFAULT_MILAGE_VALUE } from "./sliderTools";

export interface SliderProps {
  value: number;
  onChange: (newValue: number) => void;
}

const Slider: React.FC<SliderProps> = ({ value, onChange }) => {
  const handleChange = useCallback(
    (sliderValue: number) => {
      onChange(sliderValue);
    },
    [onChange],
  );

  return (
    <Box>
      <MUISlider
        defaultValue={DEFAULT_MILAGE_VALUE}
        step={1000}
        min={1000}
        max={100000}
        value={value}
        onChange={(_, sliderValue) => handleChange(Number(sliderValue))}
        aria-label="Small"
        valueLabelDisplay="auto"
      />
    </Box>
  );
};

export default Slider;
